import { render, staticRenderFns } from "./MiguelTreeView.vue?vue&type=template&id=4913c89a&scoped=true"
import script from "./MiguelTreeView.vue?vue&type=script&lang=js"
export * from "./MiguelTreeView.vue?vue&type=script&lang=js"
import style0 from "./MiguelTreeView.vue?vue&type=style&index=0&id=4913c89a&prod&lang=css"
import style1 from "./MiguelTreeView.vue?vue&type=style&index=1&id=4913c89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4913c89a",
  null
  
)

export default component.exports